import * as R from 'ramda';
import { authRequest } from './utils';

/**
 * fetchOrganizationSettings :: _ -> Promise Error Object
 */
export const fetchOrganizationSettings = () => authRequest({
  method: 'GET',
  url: '/organization-settings',
})
  .then(({ data }) => data);

/**
 * createRequestSource :: Object -> Promise Error Object
 */
export const createRequestSource = data =>
  authRequest({
    method: 'POST',
    url: '/organization-settings/request-sources',
    data,
  })
    .then(({ data: { requestSource } }) => requestSource);

/**
 * deleteRequestSourceById :: ID -> Promise Error Object
 */
export const deleteRequestSourceById = _id =>
  authRequest({
    method: 'DELETE',
    url: `/organization-settings/request-sources/${_id}`,
  })
    .then(({ data: { requestSource } }) => requestSource);

/**
 * updateRequestSourceById :: ID -> Object -> Promise Error Object
 */
export const updateRequestSourceById = R.curry((_id, data) =>
  authRequest({
    method: 'PATCH',
    url: `/organization-settings/request-sources/${_id}`,
    data,
  })
    .then(({ data: { requestSource } }) => requestSource));

/**
 * createRequestStatus :: Object -> Promise Error Object
 */
export const createRequestStatus = data =>
  authRequest({
    method: 'POST',
    url: '/organization-settings/request-statuses',
    data,
  })
    .then(({ data: { requestStatus } }) => requestStatus);

/**
 * deleteRequestStatusById :: ID -> Promise Error Object
 */
export const deleteRequestStatusById = _id =>
  authRequest({
    method: 'DELETE',
    url: `/organization-settings/request-statuses/${_id}`,
  })
    .then(({ data: { requestStatus } }) => requestStatus);

/**
 * updateRequestStatusById :: ID -> Object -> Promise Error Object
 */
export const updateRequestStatusById = R.curry((_id, data) =>
  authRequest({
    method: 'PATCH',
    url: `/organization-settings/request-statuses/${_id}`,
    data,
  })
    .then(({ data: { requestStatus } }) => requestStatus));

/**
 * createRequestLabel :: Object -> Promise Error Object
 */
export const createRequestLabel = data =>
  authRequest({
    method: 'POST',
    url: '/organization-settings/request-labels',
    data,
  })
    .then(({ data: { requestLabel } }) => requestLabel);

/**
 * deleteRequestLabelById :: ID -> Promise Error Object
 */
export const deleteRequestLabelById = _id =>
  authRequest({
    method: 'DELETE',
    url: `/organization-settings/request-labels/${_id}`,
  })
    .then(({ data: { requestLabel } }) => requestLabel);

/**
 * updateRequestLabelById :: ID -> Object -> Promise Error Object
 */
export const updateRequestLabelById = R.curry((_id, data) =>
  authRequest({
    method: 'PATCH',
    url: `/organization-settings/request-labels/${_id}`,
    data,
  })
    .then(({ data: { requestLabel } }) => requestLabel));



// WEBPACK FOOTER //
// ./src/api/apiko-api/organization-settings.js